/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Whether_Youre_Clearing_Out_YoInputs */

const en_whether_youre_clearing_out_yo = /** @type {(inputs: Whether_Youre_Clearing_Out_YoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Whether you're clearing out your closet, launching a digital course, or selling your car. Get a free professional storefront in minutes, drop the link in your socials, and start making money.`)
};

const es_whether_youre_clearing_out_yo = /** @type {(inputs: Whether_Youre_Clearing_Out_YoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ya sea que estés limpiando tu armario, lanzando un curso digital o vendiendo tu coche. Obtén una tienda profesional gratis en minutos, pon el enlace en tus redes sociales y comienza a ganar dinero.`)
};

const fr_whether_youre_clearing_out_yo = /** @type {(inputs: Whether_Youre_Clearing_Out_YoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Que vous fassiez le tri dans votre placard, lanciez un cours numérique ou vendiez votre voiture. Obtenez une vitrine professionnelle gratuite en quelques minutes, déposez le lien sur vos réseaux sociaux et commencez à gagner de l'argent.`)
};

const de_whether_youre_clearing_out_yo = /** @type {(inputs: Whether_Youre_Clearing_Out_YoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Egal, ob du deinen Kleiderschrank ausräumst, einen digitalen Kurs startest oder dein Auto verkaufst. Hol dir in wenigen Minuten eine kostenlose professionelle Storefront, setze den Link in deine Social-Media-Profile und fang an, Geld zu verdienen.`)
};

const ja_whether_youre_clearing_out_yo = /** @type {(inputs: Whether_Youre_Clearing_Out_YoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`クローゼットの整理、デジタルコースの立ち上げ、車の販売など、どんな目的でも大丈夫です。プロフェッショナルなストアフロントを数分で無料で作成し、SNSにリンクを貼って収益化を始めましょう。`)
};

const zh_whether_youre_clearing_out_yo = /** @type {(inputs: Whether_Youre_Clearing_Out_YoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`无论您是清理衣橱、发布数字课程，还是出售爱车。几分钟内获得一个免费的专业店铺，将链接发布到您的社交媒体上，开始赚钱吧。`)
};

const ar_whether_youre_clearing_out_yo = /** @type {(inputs: Whether_Youre_Clearing_Out_YoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`سواء كنت تقوم بتفريغ خزانتك، أو إطلاق دورة رقمية، أو بيع سيارتك. احصل على واجهة متجر احترافية مجانية في دقائق، ضع الرابط في حسابات التواصل الاجتماعي الخاصة بك، وابدأ في كسب المال.`)
};

const id_whether_youre_clearing_out_yo = /** @type {(inputs: Whether_Youre_Clearing_Out_YoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Baik Anda sedang mengosongkan lemari, meluncurkan kursus digital, atau menjual mobil Anda. Dapatkan etalase profesional gratis dalam hitungan menit, taruh tautannya di media sosial Anda, dan mulailah menghasilkan uang.`)
};

const it_whether_youre_clearing_out_yo = /** @type {(inputs: Whether_Youre_Clearing_Out_YoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sia che tu stia svuotando l'armadio, lanciando un corso digitale o vendendo la tua auto. Ottieni una vetrina professionale gratuita in pochi minuti, inserisci il link sui tuoi social e inizia a guadagnare.`)
};

const ru_whether_youre_clearing_out_yo = /** @type {(inputs: Whether_Youre_Clearing_Out_YoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Независимо от того, разбираете ли вы шкаф, запускаете цифровой курс или продаете свой автомобиль. Получите бесплатную профессиональную витрину за считанные минуты, оставьте ссылку в своих соцсетях и начните зарабатывать.`)
};

const pt_whether_youre_clearing_out_yo = /** @type {(inputs: Whether_Youre_Clearing_Out_YoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seja para esvaziar seu armário, lançar um curso digital ou vender seu carro. Obtenha uma vitrine profissional gratuita em minutos, coloque o link nas suas redes sociais e comece a ganhar dinheiro.`)
};

const ko_whether_youre_clearing_out_yo = /** @type {(inputs: Whether_Youre_Clearing_Out_YoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`옷장을 정리하든, 디지털 코스를 런칭하든, 자동차를 판매하든 상관없습니다. 몇 분 만에 무료 전문 스토어프론트를 만들고 소셜 미디어에 링크를 공유하여 수익 창출을 시작하세요.`)
};

/**
* | output |
* | --- |
* | "Whether you're clearing out your closet, launching a digital course, or selling your car. Get a free professional storefront in minutes, drop the link in you..." |
*
* @param {Whether_Youre_Clearing_Out_YoInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const whether_youre_clearing_out_yo = /** @type {((inputs?: Whether_Youre_Clearing_Out_YoInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Whether_Youre_Clearing_Out_YoInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_whether_youre_clearing_out_yo(inputs)
	if (locale === "es") return es_whether_youre_clearing_out_yo(inputs)
	if (locale === "fr") return fr_whether_youre_clearing_out_yo(inputs)
	if (locale === "de") return de_whether_youre_clearing_out_yo(inputs)
	if (locale === "ja") return ja_whether_youre_clearing_out_yo(inputs)
	if (locale === "zh") return zh_whether_youre_clearing_out_yo(inputs)
	if (locale === "ar") return ar_whether_youre_clearing_out_yo(inputs)
	if (locale === "id") return id_whether_youre_clearing_out_yo(inputs)
	if (locale === "it") return it_whether_youre_clearing_out_yo(inputs)
	if (locale === "ru") return ru_whether_youre_clearing_out_yo(inputs)
	if (locale === "pt") return pt_whether_youre_clearing_out_yo(inputs)
	return ko_whether_youre_clearing_out_yo(inputs)
});